"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Typography_1 = __importDefault(require("../../../../Typography"));
var Title = function (_a) {
    var children = _a.children;
    return (typeof children === 'string'
        ? react_1.default.createElement(Typography_1.default, { color: "textPrimary" }, children)
        : react_1.default.createElement(react_1.default.Fragment, null, children));
};
exports.default = Title;
